import avaleht from "./pages/et/avaleht.i18n";
import majutus from "./pages/et/majutus.i18n";
import yritused from "./pages/et/yritused.i18n";
import sadam from "./pages/et/sadam.i18n";
import karavan from "./pages/et/karavan.i18n";
import tegevused from "./pages/et/tegevused.i18n";
import kontakt from "./pages/et/kontakt.i18n";
import toitlustus from "./pages/et/toitlustus.i18n";
import projekt from "./pages/et/projekt.i18n";

import React from "react";

const yld = {
  "yld.hinnakiri": "Hinnakiri",
  "yld.kysipakkumist": "Küsi pakkumist",
  "yld.kaardid.loelahemalt": "Loe lähemalt",
  "yld.navigatsioon.avaleht": "Avaleht",
  "yld.navigatsioon.majutus": "Majutus",
  "yld.navigatsioon.motell": "Motell",
  "yld.navigatsioon.ridaelamud": "Ridaelamud",
  "yld.navigatsioon.saunamajad": "Saunamajad",
  "yld.navigatsioon.palkmajad": "Palkmajad",
  "yld.navigatsioon.kampingud": "Kämpingud",
  "yld.navigatsioon.yritused": "Üritused",
  "yld.navigatsioon.suvepaevad": "Suvepäevad",
  "yld.navigatsioon.synnipaevad": "Sünnipäevad",
  "yld.navigatsioon.pulmad": "Pulmad",
  "yld.navigatsioon.seminarid": "Seminarid",
  "yld.navigatsioon.toitlustus": "Toitlustus",
  "yld.navigatsioon.sadam": "Sadam",
  "yld.navigatsioon.karavan": "Karavanid & telkimine",
  "yld.navigatsioon.tegevused": "Tegevused",
  "yld.navigatsioon.windsurf": "Windsurf",
  "yld.navigatsioon.sup": "Sup",
  "yld.navigatsioon.pallimangud": "Pallimängud",
  "yld.navigatsioon.discgolf": "DiscGolf",
  "yld.navigatsioon.piljard": "Baar & piljard",
  "yld.navigatsioon.saunad": "Saunad",
  "yld.navigatsioon.paadirent": "Paadirent & kalastus",
  "yld.navigatsioon.jalgrattarent": "Jalgrattarent",
  "yld.navigatsioon.jahindus": "Jahindus",
  "yld.navigatsioon.koostoopartnerid": "Seiklusüritused koostööpartneritelt",
  "yld.navigatsioon.galerii": "Galerii",
  "yld.navigatsioon.kontakt": "Kontakt",
  "yld.navigatsioon.covid": "COVID-19",
  "yld.navigatsioon.köögiprojekt": "Projekt",
  "yld.keel": "Keel",
  covid: () => (
    <>
      <h2 className="title is-2">Infoks Covid-19 kohta</h2>
      <p>
        Visit Pärnu poolt välja antud märgisega “Siin on COVID-19 turvaline”
        kinnitame, et järgime meie tegutsemisvaldkonnale kehtestatud{" "}
        <a
          href="https://kriis.ee/kriisi-juhtimine-kusimused-ja-vastused/kriisi-juhtimine/oigusaktid-ja-seletuskirjad"
          target="_blank"
          rel="noopener noreferrer"
        >
          Vabariigi Valitsuse
        </a>{" "}
        korraldusi ja{" "}
        <a
          href="https://www.terviseamet.ee/et/koroonaviirus/koroonaviiruse-haigus-covid-19-trukised-ja-juhendmaterjalid"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terviseameti
        </a>{" "}
        juhiseid, hoiame end nende järgimiseks infoga pidevalt kursis ning
        aitame külastajatel täita kohapeal viiruse vältimise reegleid.
      </p>
      <p>Meie juures võid kindel olla et:</p>
      <ul>
        <li>
          külastaja käitumisjuhis ja teave meie poolt kasutusele võetud Covid-19
          viiruse leviku tõkestamise tegevuste kohta on kättesaadav
        </li>
        <li>
          kogu personal on teadlik viiruse leviku tõkestamise juhistest ja
          järgib neid igapäevatöös
        </li>
        <li>siseruumide ventilatsioonisüsteem töötab nõuetekohaselt;</li>
        <li>
          desovahendeid on piisavalt, need on kõikidele nähtavates kohtades
          kättesaadavad
        </li>
        <li>
          sageli puudutatavaid pindu puhastatakse ja desinfitseeritakse
          regulaarselt
        </li>
        <li>
          personalil ja külastajatel palutakse vastavalt kehtivatele riiklikele
          regulatsioonidele kanda maski või alternatiivset isikukaitsevahendit
        </li>
        <li>
          tagatud vajaliku distantsi hoidmise võimalus nii omavahel kui
          teenindajatega
        </li>
        <li>
          haigustunnustega inimestel ei ole lubatud viibida avalikes ruumides
          ega teenindusalas
        </li>
        <li>
          haigustunnustega kliendi või töötajaga kokku puutunud inimesi
          teavitatakse kokkupuutest, avaldamata isikuandmeid
        </li>
        <li>
          osaleme ka Ettevõtluse Arendamise Sihtasutuse korraldatavatel COVID-19
          leviku tõkestamist käsitlevatel veebiseminaridel.
        </li>
      </ul>
    </>
  ),
};

const translations = Object.assign(
  yld,
  avaleht,
  toitlustus,
  majutus,
  yritused,
  sadam,
  karavan,
  tegevused,
  kontakt,
  projekt
);

export default translations;
